import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Check: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.47 2.233a.875.875 0 0 1 .047 1.236L6.142 13.594a.875.875 0 0 1-1.307-.026L.46 8.443a.875.875 0 0 1 1.33-1.136l3.737 4.376 8.706-9.402a.875.875 0 0 1 1.236-.048Z"
            ></path>
        </Icon>
    );
};
